import React, { useState } from 'react';
import { ReadOnlyGuard, SparkIcon } from '@spark';
import SettingsSectionCard from './SettingsSectionCard.jsx';
import './settings.css';

/**
 * Hardware Device tab (Figma frame 6023-808): description + two selectable
 * cards (32px GPU-rabbit / CPU-turtle icons, 14px semibold label, 199px
 * centered description) with a 1px default / brand border for the selection.
 */
const DEVICE_OPTIONS = [
    {
        value: 'gpu',
        label: 'GPU',
        description: 'Force training to use GPU for faster processing time',
        iconSlug: 'hardware-gpu-rabbit',
    },
    {
        value: 'cpu',
        label: 'CPU',
        description: 'Force training to use CPU (slower processing time)',
        iconSlug: 'hardware-cpu-turtle',
    },
];

const HardwareDevice = ({ selectedDevice, onDeviceChange }) => {
    const [isSaving, setIsSaving] = useState(false);

    const handleDeviceChange = (device) => {
        if (isSaving || device === selectedDevice) return;
        setIsSaving(true);
        onDeviceChange(device);
        // Reset saving state after a short delay to show loading state
        setTimeout(() => setIsSaving(false), 500);
    };

    return (
        <SettingsSectionCard iconSlug="hardware-device" title="Hardware Device">
            <p className="settings-text fs-unmask">
                Set your default hardware. You can always change this for individual jobs later.
            </p>

            <ReadOnlyGuard block>
                <div className="settings-hw-cards fs-unmask" role="radiogroup" aria-label="Hardware device">
                    {DEVICE_OPTIONS.map((option) => (
                        <button
                            key={option.value}
                            type="button"
                            role="radio"
                            aria-checked={selectedDevice === option.value}
                            className={
                                'settings-hw-card'
                                + (selectedDevice === option.value ? ' settings-hw-card--selected' : '')
                            }
                            disabled={isSaving}
                            onClick={() => handleDeviceChange(option.value)}
                        >
                            <SparkIcon slug={option.iconSlug} size={32} className="settings-hw-card__icon" />
                            <span className="settings-hw-card__label">{option.label}</span>
                            <span className="settings-hw-card__description">{option.description}</span>
                        </button>
                    ))}
                </div>
            </ReadOnlyGuard>
        </SettingsSectionCard>
    );
};

export default HardwareDevice;
